(() => {
  if (customElements.get('six-cart-gifts')) return;
  // One shared controller survives cart section replacements.
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const celebrationStyle = document.createElement('style');
  celebrationStyle.textContent = `
    .cg-unlock-toast{position:fixed;bottom:28px;left:50%;transform:translateX(-50%);z-index:2147483647;pointer-events:none;box-sizing:border-box;width:max-content;max-width:calc(100vw - 32px);padding:18px 26px;border:1px solid #b99752;border-radius:14px;background:linear-gradient(120deg,#25231e,#0c0c0c);color:#fff;box-shadow:0 15px 55px #0005;text-align:center;font:700 14px/1.5 Montserrat,sans-serif;animation:cg-toast-in .35s ease-out}
    .cg-unlock-toast small{display:block;color:#e8c782;font-size:10px;letter-spacing:.18em;text-transform:uppercase;margin-bottom:4px}
    .cg-tier.cg-celebrating{border-radius:10px;animation:cg-tier-glow 1s ease-in-out 3}
    @keyframes cg-tier-glow{50%{box-shadow:0 0 0 5px #c6a15b33,0 0 30px #c6a15b22}}
    @keyframes cg-toast-in{from{opacity:0;translate:0 12px}to{opacity:1;translate:0 0}}
    @media(prefers-reduced-motion:reduce){.cg-unlock-toast,.cg-tier.cg-celebrating{animation:none}}
  `;
  document.head.append(celebrationStyle);
  let activeCelebration;
  function celebrate(tiers, host) {
    activeCelebration?.();
    const toast = document.createElement('div');
    toast.className = 'cg-unlock-toast';
    toast.setAttribute('role','status'); toast.setAttribute('aria-live','polite');
    const eyebrow = document.createElement('small');
eyebrow.textContent = tiers.length > 1 ? 'FREE GIFTS UNLOCKED' : 'FREE GIFT UNLOCKED';
    const message = document.createElement('div');
   message.textContent = tiers.length > 1
  ? `Nice! You’ve earned ${tiers.length} free gifts. Pick your favorites below.`
  : 'Nice! You’ve earned a free gift. Pick your favorite below.';
    toast.append(eyebrow,message); document.body.append(toast);
    const highlights = Array.from(document.querySelectorAll('.cg-tier')).filter(el=>tiers.some(t=>t.id===el.dataset.tier));
    if (!reducedMotion()) highlights.forEach(el=>el.classList.add('cg-celebrating'));
    let canvas, frame, timer;
    const cleanup = () => { clearTimeout(timer); if(frame) cancelAnimationFrame(frame); canvas?.remove(); toast.remove(); highlights.forEach(el=>el.classList.remove('cg-celebrating')); if(activeCelebration===cleanup) activeCelebration=null; };
    activeCelebration = cleanup;
    timer = setTimeout(cleanup,4200);
    if(reducedMotion()) return;
    canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden','true');
    canvas.style.cssText='position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483646';
    document.body.append(canvas);
    const ctx = canvas.getContext('2d'); if(!ctx) { canvas.remove(); return; }
    const w=window.innerWidth,h=window.innerHeight,dpr=Math.min(window.devicePixelRatio||1,2);
    canvas.width=w*dpr;canvas.height=h*dpr;ctx.scale(dpr,dpr);
    const rect=host.getBoundingClientRect();
    const originX=rect.width && rect.right>0 && rect.left<w ? Math.min(w-30,Math.max(30,rect.left+rect.width/2)) : w/2;
    const originY=Math.min(h*.65,Math.max(90,rect.top+50));
    const colors=['#d6b46d','#f3dba5','#ffffff','#8d7448','#a8afb4'];
    const count=w<600?90:145;
    const particles=Array.from({length:count},()=>({x:originX,y:originY,vx:(Math.random()-.5)*17,vy:-5-Math.random()*12,rotation:Math.random()*Math.PI,spin:(Math.random()-.5)*.3,size:4+Math.random()*5,color:colors[Math.floor(Math.random()*colors.length)]}));
    let start,last;
    const draw = now => {
      start??=now;last??=now;
      if(document.hidden || reducedMotion() || now-start>2600){canvas.remove();return;}
      const dt=Math.min((now-last)/16.667,2);last=now;
      ctx.clearRect(0,0,w,h);ctx.globalAlpha=Math.min(1,(2600-(now-start))/650);
      particles.forEach(p=>{p.vy+=.22*dt;p.vx*=Math.pow(.992,dt);p.x+=p.vx*dt;p.y+=p.vy*dt;p.rotation+=p.spin*dt;ctx.save();ctx.translate(p.x,p.y);ctx.rotate(p.rotation);ctx.fillStyle=p.color;ctx.fillRect(-p.size/2,-p.size/2,p.size,p.size*.55);ctx.restore();});
      frame=requestAnimationFrame(draw);
    };
    frame=requestAnimationFrame(draw);
  }
  const previous = new Map();
  let baselineSpend=0, initialized=false;
  function checkUnlocks(scope=document, initial=false, liveSpend=null) {
    const host=scope.matches?.('six-cart-gifts') ? scope : scope.querySelector?.('six-cart-gifts');
    if(!host) return;
    const spend=liveSpend === null ? (Number(host.dataset.spend)||0) : liveSpend;
    const newly=[];
    host.querySelectorAll('.cg-tier').forEach(tier=>{
      const threshold=Number(tier.dataset.threshold);
      const key=`${host.dataset.basis}:${tier.dataset.tier}:${threshold}`;
      const unlocked=spend>=threshold;
      const was=previous.has(key)?previous.get(key):baselineSpend>=threshold;
      if(!(initial && !initialized) && unlocked && !was) {
        newly.push({id:tier.dataset.tier,label:tier.querySelector('strong')?.textContent.trim()||'Gift'});
      }
      previous.set(key,unlocked);
    });
    baselineSpend=spend; initialized=true;
    if(newly.length) celebrate(newly,host);
  }
  // Bundle products and selected gifts do not count toward free gift thresholds.
  function qualifyingGiftSpend(cart, basis) {
    return cart.items.reduce((sum, item) => {
      const productType = String(item.product_type || '').trim().toLowerCase();
      if (item.properties?._six_gift_tier || productType === 'bundle') return sum;
      return sum + (basis === 'final' ? item.final_line_price : item.original_line_price);
    }, 0);
  }
  // Read authoritative cart data rather than depending on section refresh timing.
  let unlockTimer, unlockSequence=0;
  function scheduleUnlocks(scope) {
    const sequence=++unlockSequence;
    clearTimeout(unlockTimer);
    unlockTimer=setTimeout(async()=>{
      const container=scope?.isConnected ? scope : document;
      const host=container.matches?.('six-cart-gifts') ? container : container.querySelector?.('six-cart-gifts') || document.querySelector('six-cart-gifts');
      if(!host) { baselineSpend=0; previous.forEach((value,key)=>previous.set(key,false)); return; }
      try {
        const cart=await request('cart.js');
        if(sequence!==unlockSequence) return;
        const spend=qualifyingGiftSpend(cart, host.dataset.basis);
        if(host.isConnected) checkUnlocks(host,false,spend);
      } catch(error) {
        if(sequence===unlockSequence && host.isConnected) checkUnlocks(host);
      }
    },120);
  }
  document.addEventListener('on:cart:change',event=>scheduleUnlocks(event.target));
  document.addEventListener('on:cart:after-merge',event=>scheduleUnlocks(event.target));
  document.addEventListener('on:cart:add',()=>scheduleUnlocks(document));
  document.addEventListener('shopify:section:load',event=>scheduleUnlocks(event.target));
  // Also cover apps that replace cart markup without emitting theme events.
  const giftObserver=new MutationObserver(records=>{
    if(records.some(record=>Array.from(record.addedNodes).some(node=>node.nodeType===1 && (node.matches?.('six-cart-gifts') || node.querySelector?.('six-cart-gifts'))))) scheduleUnlocks(document);
  });
  giftObserver.observe(document.body,{childList:true,subtree:true});
  window.addEventListener('pagehide',()=>activeCelebration?.());

  let busy = false;
  const root = () => window.Shopify?.routes?.root || '/';
  async function request(path, body) {
    const response = await fetch(root() + path, body ? {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)} : {headers:{Accept:'application/json'},cache:'no-store'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update cart. Please try again.');
    return data;
  }
  checkUnlocks(document,true);
  customElements.define('six-cart-gifts', class extends HTMLElement {
    connectedCallback() {
      scheduleUnlocks(this);
      if (this.bound) return;
      this.bound = true;
      this.querySelectorAll('[data-product-open]').forEach(button => {
        const product = JSON.parse(button.querySelector('script').textContent);
        if (product.variants.length === 1 && product.variants[0].available) {
          const label = button.querySelector('small');
          if (label) label.textContent = 'Add gift';
        }
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-product-open]');
        if (!button || button.disabled) return;
        this.openGift(button);
      });
    }
    disconnectedCallback() { this.dialog?.close(); }
    async addGiftVariant(variantId, tier) {
      const cart = await request('cart.js');
      const spend = qualifyingGiftSpend(cart, this.dataset.basis);
      if (spend < Number(tier.dataset.threshold)) throw new Error('Your cart no longer qualifies for this tier. Refresh your cart to see current eligibility.');
      if (cart.items.some(item => String(item.properties?._six_gift_tier) === tier.dataset.tier)) throw new Error('A gift is already selected for this tier. Remove it from your cart before choosing another.');
      await request('cart/add.js',{items:[{id:Number(variantId),quantity:1,properties:{_six_gift_tier:tier.dataset.tier}}]});
    }
    async quickAddGift(button, variant, tier) {
      if (busy || !variant.available) return;
      busy = true;
      button.disabled = true;
      button.setAttribute('aria-busy','true');
      const label = button.querySelector('small');
      const oldLabel = label?.textContent;
      if (label) label.textContent = 'Adding…';
      let status = this.querySelector('[data-cg-quick-status]');
      if (!status) {
        status = document.createElement('p');
        status.dataset.cgQuickStatus = '';
        status.setAttribute('role','status');
        status.setAttribute('aria-live','polite');
        status.style.cssText = 'font-size:12px;line-height:1.5;margin:10px 0';
        this.append(status);
      }
      status.textContent = 'Adding gift…';
      try {
        await this.addGiftVariant(variant.id, tier);
        if (label) label.textContent = 'Added';
        status.textContent = 'Gift added to your cart.';
        document.dispatchEvent(new CustomEvent('on:cart:change',{bubbles:true}));
      } catch (error) {
        status.textContent = error.message;
        button.disabled = false;
        if (label) label.textContent = oldLabel;
      } finally {
        busy = false;
        button.removeAttribute('aria-busy');
      }
    }
    openGift(button) {
      const product = JSON.parse(button.querySelector('script').textContent);
      const tier = button.closest('[data-tier]');
      if (product.variants.length === 1) {
        this.quickAddGift(button, product.variants[0], tier);
        return;
      }
      const dialog = document.createElement('dialog');
      dialog.className = 'cg-dialog';
      dialog.setAttribute('aria-label', 'Choose gift options');
      dialog.innerHTML = '<button type="button" class="cg-close" aria-label="Close">×</button><img alt=""><h3></h3><label>Choose an option<select></select></label><p role="status" aria-live="polite"></p><button type="button" class="cg-add">Add gift</button>';
      dialog.querySelector('h3').textContent = product.title;
      const select = dialog.querySelector('select');
      product.variants.filter(v => v.available).forEach(v => select.add(new Option(v.title === 'Default Title' ? 'Standard' : v.title, String(v.id))));
      const change = () => {
        const variant = product.variants.find(v => String(v.id) === select.value);
        const img = dialog.querySelector('img');
        img.hidden = !variant?.image;
        if (variant?.image) { img.src = variant.image; img.alt = product.title; }
      };
      select.addEventListener('change', change); change();
      const close = dialog.querySelector('.cg-close');
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { dialog.remove(); if(button.isConnected) button.focus(); });
      const add = dialog.querySelector('.cg-add');
      add.disabled = !select.value;
      add.addEventListener('click', async () => {
        if(busy) return;
        busy = true; add.disabled = true;
        const status = dialog.querySelector('[role=status]');
        status.textContent = 'Adding gift…';
        try {
          await this.addGiftVariant(select.value, tier);
          dialog.close();
          document.dispatchEvent(new CustomEvent('on:cart:change',{bubbles:true}));
        } catch(error) { status.textContent = error.message; }
        finally { busy = false; add.disabled = !select.value; }
      });
      this.dialog = dialog; document.body.append(dialog); dialog.showModal();
    }
  });
})();
